import { Grid, IconButton, Stack, Tooltip } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import IGridComponent from '../../../components/grid/i-grid.component';
import { isEmpty, isEmptyArray, isNotEmpty, isNotEmptyArray, isNotNull } from '../../common/util.services';
import SpecsComponent from '../../master-data/specs/specs.component';
import MasterDetailComponent from '../master-detail/master-detail.component';
import './costing-detail.component.scss';
import DependencyFormComponent from './dependency-form.component';
import EditCellComponent from './edit-cell.component';
import TextComponent from '../../enquiry/enq-product/edit-text.component';
import OutputSplitComponent from './output-split.component';
import { getMasterDataById } from '../../master-data/masterdata.services';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { AddCircleOutline } from '@mui/icons-material';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';

const CostingDetailComponent = (props: any) => {
  const [open, setOpen] = useState(false);
  const [addRowIndex, setAddRowIndex] = useState(0);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openCellValue, setOpenCellValue] = useState(false);
  const [openOutDesc, setOpenOutDesc] = useState(false);
  const [openOutSplit, setOpenOutSplit] = useState(false);
  const [outputSplitMap, setOutputSplitMap] = useState<Map<string, string>>(new Map());
  const [cellTitle, setCellTitle] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [openDependency, setOpenDependency] = useState(false);
  const rows: GridRowsProp = [];
  const [detailRows, setDetailRows] = useState(rows);
  const [popupRowData, setPopupRowData] = useState(null);
  const appContext = useContext(AppContext);
  const [cellValueRow, setCellValueRow] = useState(null);
  const [dependencyRow, setDependencyRow] = useState(null);
  const [rowData, setRowData] = useState<any>([]);
  const [message, setMessage] = useState('');
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  const [dependencyValues, setDependencyValues] = useState<string[]>([]);
  const [correctDependency, setCorrectDependency] = useState(true);
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};

  const columns: GridColDef[] = [
    { field: 'serial', headerName: '#', filterable: false, sortable: false, width: 5 },
    { 
      field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 100,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>{params.row.code}</div> }
    },
    {
      field: 'dependency', headerName: 'Dependency', filterable: false, sortable: false, width: 100, editable: false,
      valueSetter: (value, row) => { row.dependency = value; return value; }
    },
    {
      field: 'processLossPercentage', headerName: 'PL', filterable: false, sortable: false, width: 60, editable: false,
      valueFormatter: (processLossPercentage: any) => processLossPercentage + '%'
    },
    { field: 'unitCost', headerName: 'Unit Rate', filterable: false, sortable: false, width: 120, editable: false,
      renderCell: (params) => isEmpty(params.row.unitCost) ? '' : '₹ ' + params.row.unitCost + ' / ' + params.row.uom
    },
    {
      field: 'consumption', headerName: '# Units', filterable: false, sortable: false, width: 110, 
      renderCell: (params: any) => (params.row.consumption * 1).toFixed(3) + ' ' + params.row.uom
    },
    {
      field: 'consumptionCost', headerName: 'Cost', filterable: false, sortable: false, width: 90,
      valueFormatter: (consumptionCost: any) => '₹ ' + consumptionCost.toFixed(3)
    },
    {
      field: 'outputDesc', headerName: 'Output Details', filterable: false, sortable: false, width: 320, editable: false,
      valueSetter: (value, row) => { row.outputDesc = value; return value; }
    },
    {
      field: 'output', headerName: 'O/P Qty', filterable: false, sortable: false, width: 75, editable: false,
      valueSetter: (value, row) => { row.output = value; return value; }
    },
    {
      field: 'outputUom', headerName: 'O/P UOM', filterable: false, sortable: false, width: 80, editable: true, type: 'singleSelect',
      valueOptions: ['Cm', 'Cu Cm', 'Cu Ft', 'Cu Mtr', 'Feet', 'Gm', 'Inch', 'Kg', 'Mm', 'Mtr', 'Pack', 'Pc', 'Sq Cm', 'Sq Inch', 'Sq Mtr'],
      valueFormatter: (outputUom: any) => outputUom, 
      valueSetter: (value, row) => { row.outputUom = value; return value; }
    },
    {
      field: 'outputSplit', headerName: 'O/P Split (%)', filterable: false, sortable: false, width: 100, editable: false,
      valueSetter: (value, row) => { row.outputSplit = value; return value; },
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.outputSplit)}
      PopperProps={popperProps}>{params.row.outputSplit}</Tooltip>)
    },
    {
      field: 'multiplier', headerName: 'Multiplier', filterable: false, sortable: false, width: 80, editable: false,
      valueFormatter: (multiplier: any) => multiplier.toFixed(3)
    },
    { field: 'action', headerName: 'Actions', filterable: false, sortable: false, editable: false, width: 85,
      renderCell: (params: any) => (<Stack direction="row" spacing={-1.5} alignItems="center"
                                      justifyContent="center" sx={{ width: '100%', height: '100%' }}>
                                      <Tooltip title={'Delete Input'} PopperProps={popperProps}>
                                        <IconButton onClick={() => deleteCosting(params.row)} >
                                          <DeleteIcon fontSize="small" color='secondary'></DeleteIcon>
                                        </IconButton></Tooltip>
                                      <Tooltip title={'Add Input'} PopperProps={popperProps}>
                                        <IconButton onClick={() => addCosting(params.row)} >
                                          <AddCircleOutline fontSize="small" color='secondary'></AddCircleOutline>
                                        </IconButton></Tooltip>
                                    </Stack>)
    }
  ];

  useEffect(() => {
    if (isNotEmptyArray(props.costingData)) {
      setDetailRows(updateSerialNumber([...props.costingData]));
      updateOutSplitMap(props.costingData);
    }

    updateDependencyValues(props.costingData);
  }, [props.costingData]);

  useEffect(() => {
    calculateCost(detailRows, outputSplitMap);
    if (props.processRowUpdate) {
      props.processRowUpdate(detailRows);
    }
  }, []);

  function getLinkIdFromCode(code: string, rows: any) {
    for(let i = 0; i < rows.length; ++i) {
      if(code === rows[i].code) {
        return rows[i].linkId;
      }
    }
  }

  function getLinkIdFromSerial(serial: string, rows: any) {
    for(let i = 0; i < rows.length; ++i) {
      if(serial === rows[i].serial) {
        return rows[i].linkId;
      }
    }
  }

  function getCodeFromLinkId(linkId: string, rows: any) {
    for(let i = 0; i < rows.length; ++i) {
      if(linkId === rows[i].linkId) {
        return rows[i].code;
      }
    }
  }

  function updateOutSplitMap(rows: any) {
    let outSplitMap: Map<string, string> = new Map();
    for(let i = 0; i < rows.length; ++i) {
      if(isEmpty(rows[i].outputSplit) || rows[i].outputSplit.includes('NA')) {
        continue;
      }
      let array = rows[i].outputSplit.split(',');
      for(let j = 0; j < array.length; ++j) {
        let linkId = getLinkIdFromCode(array[j].split('=')[0], rows);
        let splitVal = array[j].split('=')[1];
        outSplitMap.set(rows[i].linkId + '-' + linkId, splitVal);
      }
    }
    
    setOutputSplitMap(outSplitMap);

    return outSplitMap;
  }

  const updateDependencyValues = (detailRows: any) => {
    let values = ['NA'];
    let length = 0;
    if(isNotEmpty(detailRows)) {
      length = detailRows.length;
    }
    for(let i = 1; i <= length; ++i) {
      values[i] = i.toString() + ' - ' + detailRows[i - 1].code;
    }
    setDependencyValues(values);
  }

  const openSpecsPopup = (params: any) => {
    getMasterDataById(params.row.inputId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPopupRowData(response.data);
        setOpenSpecs(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const openMasterPopup = (params: any) => {
    setAddRowIndex(0);
    setOpen(true);
  }

  function getTooltip (outputSplit: string) {
    if( isEmpty(outputSplit) || outputSplit.includes('NA')) {
      return outputSplit;
    }
    let array = outputSplit.split(',');
    for(let i = 0; i < array.length; ++i) {
      array[i] = array[i].replaceAll('=', ': ');
      array[i] += '%'
      array[i] = array[i].replaceAll('null%', 'NA');
      if('%' === array[i].split(': ')[1]) {
        array[i] = array[i].replaceAll('%', 'NA');
      }
    }

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getDependencyArray(array: any) {
    let dependencyArray: any = [];
    for(let i = 0; i < array.length; ++i) {
      if('NA' === array[i]) {
        dependencyArray.push('NA');
      } else {
        dependencyArray.push(array[i] + ' - ' + detailRows[array[i] - 1].code);
      }
    }

    return dependencyArray;
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    if('unitCost' === field) {
      setCellValueRow(value.row);
      setCellTitle('Specify Unit Cost');
      setCellLabel('Unit Cost');
      openCellValuePopup();
    } else if('output' === field) {
      setCellValueRow(value.row);
      setCellTitle('Specify Output Quantity');
      setCellLabel('Output Quantity');
      openCellValuePopup();
    } else if('outputDesc' === field) {
      setCellValueRow(value.row);
      setCellTitle('Specify Output Details');
      setCellLabel('Output Details');
      openOutDescPopup();
    } else if('outputSplit' === field && 'NA' !== value.row.outputSplit && isNotEmpty(value.row.outputSplit)) {
      setCellValueRow(value.row);
      openOutSplitPopup();
    } else if('processLossPercentage' === field && 'Material' !== value.row.type) {
      setCellValueRow(value.row);
      setCellTitle('Specify Process Loss');
      setCellLabel('Process Loss');
      openCellValuePopup();
    } else if('consumption' === field) {
      setCellValueRow(value.row);
      setCellTitle('Specify Consumption');
      setCellLabel('Consumption');
      openCellValuePopup();
    }

    if('dependency' === field && 'Material' !== value.row.type) {
      value.row.dependency = getDependencyArray(value.row.dependency);
      setDependencyRow(value.row);
      openDependencyPopup();
    }
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleCloseSpecs = () => {
    setOpenSpecs(false);
  }

  const closeCellValuePopup = () => {
    calculateCost(detailRows, outputSplitMap);
    setOpenCellValue(false);
    if (props.processRowUpdate) {
      props.processRowUpdate(detailRows);
    }
  }

  const openCellValuePopup = () => {
    setOpenCellValue(true);
  }

  const openOutDescPopup = () => {
    setOpenOutDesc(true);
  }

  const closeOutDescPopup = () => {
    setOpenOutDesc(false);
  }

  const openOutSplitPopup = () => {
    setOpenOutSplit(true);
  }

  const closeOutSplitPopup = () => {
    let map = updateOutSplitMap(detailRows);
    updateOutSplit(detailRows, map);
    calculateCost(detailRows, map);
    setOpenOutSplit(false);
    if (props.processRowUpdate) {
      props.processRowUpdate(detailRows);
    }
  }

  function getSerial(array: any) {
    let dependencyArray = [];
    for(let i = 0; i < array.length; ++i) {
      if('NA' === array[i]) {
        dependencyArray.push('NA');
      } else {
        dependencyArray.push(array[i].split(' - ')[0].trim());
      }
    }

    return dependencyArray;
  }

  function updateOutSplit(rows: any, map: any) {
    let valueMap: Map<string, string> = new Map();
    if(isNotNull(map)) {
      valueMap = map;
    } else {
      valueMap = outputSplitMap;
    }

    let outSplitMap: Map<string, any> = new Map();
    for(let i = 0; i < rows.length; ++i) {
      let array = rows[i].dependency;
      if(isEmptyArray(array) || array.includes('NA')) {
        continue;
      }
      
      for(let j = 0; j < array.length; ++j) {
        let linkId = getLinkIdFromSerial(rows[i].serial, rows);
        let value: any = isEmptyArray(outSplitMap.get(array[j])) ? [] : outSplitMap.get(array[j]);
        value.push(linkId);
        outSplitMap.set(array[j], value);
      }
    }

    for(let i = 0; i < rows.length; ++i) {
      let value = outSplitMap.get(rows[i].serial.toString());
      if(isEmptyArray(value) || 1 === value.length) {
        rows[i].outputSplit = 'NA';
      } else {
        let outSplit: string = '';
        for(let j = 0; j < value.length; ++j) {
          let splitVal = valueMap.get(rows[i].linkId + '-' + value[j]);
          outSplit += getCodeFromLinkId(value[j], rows) + '=' + (isEmpty(splitVal) ? '' : splitVal) + ',';
        }
        rows[i].outputSplit = outSplit.substring(0, outSplit.length - 1)
      }
    }

    updateOutSplitMap(rows);
    calculateCost(rows, valueMap);
  }

  function checkOutputSplit() {
    for(let i = 0; i < detailRows.length; ++i) {
      if('NA' === detailRows[i].outputSplit) {
        continue;
      } else if (isEmpty(detailRows[i].outputSplit)){
        return false;
      } else {
        let value = detailRows[i].outputSplit.split(',');
        let splitVal = 0;
        for(let j = 0; j < value.length; ++j) {
          if(isEmpty(value[j].split('=')[1]) || value[j].split('=')[1] <= 0) {
            return false;
          }
          splitVal += +value[j].split('=')[1];
        }
        
        if(100 !== splitVal) {
          return false;
        }
      }
    }

    return true;
  }

  const closeDependencyPopup = () => {
    detailRows.forEach(element => {
      element.dependency = getSerial(element.dependency);
    });
    updateOutSplit(detailRows, null);
    calculateCost(detailRows, outputSplitMap);
    setOpenDependency(false);
    if (props.processRowUpdate) {
      props.processRowUpdate(detailRows);
    }
  }

  const openDependencyPopup = () => {
    setOpenDependency(true);
  }

  function updateDependenciesAdd(rows: any) {
    for(let i = 0; i < rows.length; ++i) {
      let array: any = rows[i].dependency;
      for(let j = 0; isNotEmptyArray(array) && j < array.length && 'NA' !== array[j]; ++j) {
        if(+array[j] > addRowIndex) {
          array[j] = (+array[j] + 1).toString();
        }
      }
      rows[i].dependency = array;
    }

    calculateCost(rows, outputSplitMap);
  }

  function updateDependenciesDelete(rows: any, serial: number) {
    for(let i = 0; i < rows.length; ++i) {
      let array: any = rows[i].dependency;
      for(let j = 0; isNotEmptyArray(array) && j < array.length && 'NA' !== array[j] && '' !== array[j]; ++j) {
        if(array[j] === serial.toString()) {
          array[j] = '-1';
        } else if(+array[j] > serial) {
          array[j] = (+array[j] - 1).toString();
        }
      }
      
      let dependencyArray = [];
      for(let k = 0; isNotEmptyArray(array) && k < array.length; ++k) {
        if(array[k] === '-1') {
          continue;
        }
        dependencyArray.push(array[k]);
      }
      rows[i].dependency = dependencyArray;
    }

    calculateCost(rows, outputSplitMap);
  }

  function validateDependencies(rows: any) {
    let values: any = [];
    for(let i = 0; i < rows.length; ++i) {
      let array: any = rows[i].dependency;

      if(array === undefined || array === null || array.length === 0 || array[0] === '') {
        return false;
      }

      for(let j = 0; isNotEmptyArray(array) && j < array.length; ++j) {
        if('NA' !== array[j]) {
          if(isEmpty(values[+array[j] - 1])) {
            values[+array[j] - 1] = 0;
          }
          ++values[+array[j] - 1];
        }
      }
    }

    return true;
  }

  function calculateCost (rows: any, splitValueMap: any) {
    setCorrectDependency(validateDependencies(rows) && checkOutputSplit());

    for(let i = 0; i < rows.length; ++i) {
      rows[i].multiplier = 1;
      rows[i].freq = 0;
    }

    for(let i = 0; i < rows.length; ++i) {
      let array: any[] = rows[i].dependency;
      if(isEmptyArray(array) || 'NA' === array[0] || '' === array[0]) {
        continue;
      } else {
        for(let j = 0; j < array.length; ++j) {
          let index = +array[j] - 1;

          if(0 === rows[index].freq) {
            let mapVal = splitValueMap.get(rows[index].linkId + '-' + rows[i].linkId);
            let split = Number(isEmpty(mapVal) || isEmpty(rows[index].outputSplit) || 'NA' === rows[index].outputSplit ? 100 : mapVal)/100;
            rows[index].multiplier = rows[i].multiplier * +split / (1 - +rows[i].processLossPercentage/100);
          } else {
            let mapVal = splitValueMap.get(rows[index].linkId + '-' + rows[i].linkId);
            let split = Number(isEmpty(mapVal) || isEmpty(rows[index].outputSplit) || 'NA' === rows[index].outputSplit ? 100 : mapVal)/100;
            rows[index].multiplier = +rows[index].multiplier + rows[i].multiplier * +split / (1 - +rows[i].processLossPercentage/100);
          }
          
          rows[index].freq = +rows[index].freq + 1;
        }
      }
    }

    for(let i = 0; i < rows.length; ++i) {
      rows[i].consumptionCost = +rows[i].consumption * +rows[i].unitCost * +rows[i].multiplier;
    }
  }

  const updateSerialNumber = (updatedRow: any) => {
    if (isNotEmptyArray(updatedRow)) {
      updatedRow.forEach((element: any, index: number) => {
        element.serial = index + 1;
      });
    }
    updateDependencyValues(updatedRow);

    return updatedRow;
  }

  function updateSubCode(code: string, rows: any) {
    let index: any = [];
    for(let i = 0; i < rows.length; ++i) {
      if(code.split('-')[0] === rows[i].code.split('-')[0]) {
        index.push(i);
      }
    }
    if(index.length > 1) {
      for(let i = 0; i < index.length; ++i) {
        rows[index[i]].code = rows[index[i]].code.split('-')[0] + '-' + (i + 1);
      }
    } else if(1 === index.length) {
      rows[index[0]].code = rows[index[0]].code.split('-')[0];
    }
  }

  const onRowSelection = (selectedRows: any) => {
    setOpen(false);
    const selectedRow = selectedRows[0];
    /*if('Transport' === selectedRow.input) {
      let uom = selectedRow.uom;
      if(!((isFabric() && 'Kg' === uom) || (!isFabric() && 'Cu Mtr' === uom))) {
        appContext.setDialogMessage('Incorrect UOM for the product\'s transport.');
        return;
      }
    }*/
    
    selectedRow.inputId = selectedRow.rowId;
    selectedRow.consumptionCost = 0;
    selectedRow.consumption = 0;
    selectedRow.multiplier = 1;
    selectedRow.dependency = 'Material' === selectedRow.type ? ['NA'] : [];
    let updatedRow;
    const rows = [...detailRows];
    rows.splice(addRowIndex, 0, selectedRow)
    updatedRow = updateSerialNumber(rows);
    setDetailRows(updatedRow);
    updateDependenciesAdd(updatedRow);
    updateSubCode(selectedRow.code, updatedRow);
    updateDependencyValues(updatedRow);
    updateOutSplit(updatedRow, null);
    if (props.onRowSelection) {
      props.onRowSelection(updatedRow);
    }
  }

  const handleDeleteAction = (row: any) => {
    const updatedRows = detailRows.filter((r) => !(r.linkId === row.linkId));
    const serialRows = updateSerialNumber(updatedRows);
    setDetailRows(serialRows);
    updateDependenciesDelete(serialRows, row.serial);
    updateSubCode(row.code, serialRows);
    updateDependencyValues(serialRows);
    updateOutSplit(serialRows, null);
    if (props.onRowDelete) {
      props.onRowDelete(serialRows);
    }
  }

  const addCosting = (row: any) => {
    setAddRowIndex(+row.serial);
    setOpen(true);
  }

  const deleteCosting = (row: any) => {
    setRowData(row);
    setMessage('Do you want to delete the input?');
    setShowSyncMsg(true);
  }

  const onOkClick = () => {
    handleDeleteAction(rowData);
  }

  return (
    <div>
      <Grid container spacing={0} sx={{ flexGrow: 1, width: '100%', height: '100%' }}>
        <IGridComponent title='Input Details (Per Piece)' rows={detailRows} columns={columns} getRowId={(row: any) => row.linkId}
          apiRef={props.apiRef} maxHeight={'65'} showAddBtn={true} showExtraText={!correctDependency} 
          extraText='Incorrect dependencies and/or output split' hideFooter={false}
          cellDoubleClick={handleCellDoubleClick} addRow={openMasterPopup} hideFooterPagination={true} />
        <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
          onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
          message={message}/>
      </Grid>
      <IDialogComponent onClose={handleClose} open={open} title='Select Input Data' 
        dialogBody={<MasterDetailComponent onRowSelection={onRowSelection} />} />
      <IDialogComponent onClose={handleCloseSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={popupRowData} />} />
      <IDialogComponent onClose={closeCellValuePopup} open={openCellValue} title={cellTitle}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeCellValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeDependencyPopup} open={openDependency} title='Dependency'
        dialogBody={<DependencyFormComponent dependencyValues={dependencyValues} data={dependencyRow} close={closeDependencyPopup}/>} />
      <IDialogComponent onClose={closeOutDescPopup} open={openOutDesc} title={cellTitle}
        dialogBody={<TextComponent data={cellValueRow} close={closeOutDescPopup} label={cellLabel} multiline={false}/>} />
      <IDialogComponent onClose={closeOutSplitPopup} open={openOutSplit} title='Specify Output Split'
        dialogBody={<OutputSplitComponent data={cellValueRow} close={closeOutSplitPopup}/>} />
    </div>
  );
}

export default CostingDetailComponent;